// Learn Section - Learning hub for Revolt tutorials, videos, Q&A, and trivia
// Follows the Section, Component & Manager System architecture

import React from 'react';
import { MainLayout } from '../../components/Layout';
import { LearnManager } from './managers/learn-manager';
import { useManager } from '../../core';
import { LearnHeader, LearnPageHeader, SearchBar, FeaturedContentGrid, LearnLoading } from './components';
import './LearnShared.css';
import './LearnSection.css';

export function LearnSection() {
  const { manager, isInitialized } = useManager(LearnManager);

  if (!isInitialized) {
    return (
      <MainLayout contentClassName="main-content--learn">
        <LearnLoading
          title="Loading Learn Content"
          subtitle="Discovering new tutorials and resources..."
        />
      </MainLayout>
    );
  }

  return (
    <MainLayout contentClassName="main-content--learn">
      {/* Fixed Learn Page Header */}
      <LearnPageHeader />

      <div className="learn-container">
        {/* Learn Header with navigation */}
        <LearnHeader />

        {/* Search Bar */}
        <SearchBar
          placeholder="Search tutorials, videos, Q&A, trivia..."
        />

        {/* Featured Content Grid */}
        <FeaturedContentGrid
          tutorialVideos={manager.getFilteredTutorialVideos()}
          questionsAnswers={manager.getFilteredQuestionsAnswers()}
          triviaQuestions={manager.getFilteredTriviaQuestions()}
          featuredVideos={manager.getFeaturedTutorialVideos()}
          featuredQA={manager.getFeaturedQuestionsAnswers()}
          featuredTrivia={manager.getFeaturedTriviaQuestions()}
        />

        {/* Future content sections can be added below */}
      </div>
    </MainLayout>
  );
}